(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-grid"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-kit-card]').forEach((kit) => {
    kit.addEventListener('click', (event) => {
      if (event.target.closest('a, button, input, label')) return;
      kit.querySelector('form')?.requestSubmit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(max-width: 799px)').matches) {
    document.querySelectorAll('.faq-section .faq__lead').forEach((item) => item.removeAttribute('open'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const toggle = document.querySelector('[data-nav-toggle]');
  const mobile = document.querySelector('[data-mobile-nav]');
  const openIcon = document.querySelector('[data-nav-open-icon]');
  const closeIcon = document.querySelector('[data-nav-close-icon]');

  const setOpen = (open) => {
    if (!toggle || !mobile) return;
    if (open) {
      mobile.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nav-open');
      if (openIcon) openIcon.hidden = true;
      if (closeIcon) closeIcon.hidden = false;
    } else {
      mobile.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nav-open');
      if (openIcon) openIcon.hidden = false;
      if (closeIcon) closeIcon.hidden = true;
    }
  };

  if (toggle && mobile) {
    toggle.addEventListener('click', () => {
      setOpen(mobile.hasAttribute('hidden'));
    });
    mobile.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setOpen(false));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-products"] && !Shopify.designMode) return;
  try {
    
  const lightbox = document.querySelector('[data-hero-lightbox]');
  if (lightbox) {
    const img = lightbox.querySelector('[data-hero-image]');
    const title = lightbox.querySelector('[data-hero-title]');
    const subtitle = lightbox.querySelector('[data-hero-subtitle]');
    const close = () => lightbox.setAttribute('hidden', '');

    document.querySelectorAll('[data-hero-open]').forEach((item) => {
      item.addEventListener('click', () => {
        const media = item.querySelector('img');
        if (img && media) {
          img.src = media.currentSrc || media.src;
          img.alt = media.alt || '';
        }
        if (title) title.textContent = item.dataset.title || '';
        if (subtitle) subtitle.textContent = item.dataset.subtitle || '';
        lightbox.removeAttribute('hidden');
      });
    });

    lightbox.addEventListener('click', close);
    const closeBtn = lightbox.querySelector('[data-hero-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const main = document.querySelector('.js-pdp-main');
      if (!main) return;
      main.src = thumb.getAttribute('data-pdp-thumb');
      document.querySelectorAll('[data-pdp-thumb]').forEach((el) => el.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-fybe"] && !Shopify.designMode) return;
  try {
    
  const meter = document.querySelector('[data-fiber-meter]');
  if (meter && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          meter.classList.add('is-inview');
          observer.disconnect();
        }
      });
    }, { threshold: 0.4 });
    observer.observe(meter);
  } else if (meter) {
    meter.classList.add('is-inview');
  }

  } catch(e) { console.error(e); }
})();
})();
